import React from "react";
import PaginatedReport from "../../../../common/components/PaginatedReport";

const convertToTableData = (data) => {
  const groupedByLevel = data.reduce((acc, item) => {
    if (!acc[item.teachingLevel]) {
      acc[item.teachingLevel] = [];
    }
    acc[item.teachingLevel].push(item);
    return acc;
  }, {});

  const processedData = [];

  const teachingLevelOrder = ["PRE_PRIMARY", "PRIMARY", "SECONDARY"];

  teachingLevelOrder.forEach((level) => {
    if (groupedByLevel[level] && groupedByLevel[level].length > 0) {
      const section = {
        teachingLevel: level,
        positions: groupedByLevel[level].map((pos) => ({
          position: pos.position,
          count: pos.count,
        })),
        total: groupedByLevel[level].reduce((sum, pos) => sum + pos.count, 0),
      };

      processedData.push(section);
    }
  });

  Object.entries(groupedByLevel).forEach(([level, positions]) => {
    if (!teachingLevelOrder.includes(level)) {
      const section = {
        teachingLevel: level,
        positions: positions.map((pos) => ({
          position: pos.position,
          count: pos.count,
        })),
        total: positions.reduce((sum, pos) => sum + pos.count, 0),
      };

      processedData.push(section);
    }
  });

  return processedData;
};

export default function PositionVacanciesChart({ data, scope }) {
  const sectionsData = convertToTableData(data);

  // Group sections into two columns
  const leftColumnSections = sectionsData.filter(section => 
    ["PRE_PRIMARY", "PRIMARY"].includes(section.teachingLevel)
  );
  const rightColumnSections = sectionsData.filter(section => 
    section.teachingLevel === "SECONDARY"
  );

  const renderTableSection = (section, usePagination = false) => {
    if (!usePagination && scope !== "RTB") {
      return (
        <div
          key={`section-${section.teachingLevel}`}
          style={{ marginBottom: "20px" }}
        >
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px 10px 10px 20px",
                    textAlign: "left",
                    backgroundColor: "rgb(1, 81, 152)",
                    color: "white",
                  }}
                >
                  {section.teachingLevel}
                </th>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    textAlign: "center",
                    backgroundColor: "rgb(1, 81, 152)",
                    color: "white",
                  }}
                >
                  Vacancies
                </th>
              </tr>
            </thead>
            <tbody>
              {section.positions.map((position, posIndex) => (
                <tr
                  key={`position-${section.teachingLevel}-${posIndex}`}
                  style={{
                    backgroundColor:
                      posIndex % 2 === 0 ? "#f9f9f9" : "#fff",
                  }}
                >
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px 10px 10px 20px",
                      paddingLeft: "40px",
                    }}
                  >
                    {position.position}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px",
                      textAlign: "center",
                      backgroundColor:
                        posIndex % 2 === 0 ? "#f9f9f9" : "#f0f0f0",
                      fontWeight: "500",
                    }}
                  >
                    {position.count?.toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr
                style={{
                  backgroundColor: "rgb(197, 221, 241)",
                  fontWeight: "bold",
                }}
              >
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px 10px 12px 20px",
                    textAlign: "right",
                    backgroundColor: "white",
                    borderBottom: "none",
                    borderLeft: "none",
                  }}
                ></td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {section.total?.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div
        key={`section-${section.teachingLevel}`}
        style={{ marginBottom: "20px" }}
      >
        <PaginatedReport
          data={section.positions}
          rowsPerPage={10}
          renderTable={(paginatedPositions) => (
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px 10px 10px 20px",
                      textAlign: "left",
                      backgroundColor: "rgb(1, 81, 152)",
                      color: "white",
                    }}
                  >
                    {section.teachingLevel}
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px",
                      textAlign: "center",
                      backgroundColor: "rgb(1, 81, 152)",
                      color: "white",
                    }}
                  >
                    Vacancies
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedPositions.map((position, posIndex) => (
                  <tr
                    key={`position-${section.teachingLevel}-${posIndex}`}
                    style={{
                      backgroundColor:
                        posIndex % 2 === 0 ? "#f9f9f9" : "#fff",
                    }}
                  >
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px 10px 10px 20px",
                        paddingLeft: "40px",
                      }}
                    >
                      {position.position}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        backgroundColor:
                          posIndex % 2 === 0 ? "#f9f9f9" : "#f0f0f0",
                        fontWeight: "500",
                      }}
                    >
                      {position.count?.toLocaleString()}
                    </td>
                  </tr>
                ))}
                <tr
                  style={{
                    backgroundColor: "rgb(197, 221, 241)",
                    fontWeight: "bold",
                  }}
                >
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px 10px 12px 20px",
                      textAlign: "right",
                      backgroundColor: "white",
                      borderBottom: "none",
                      borderLeft: "none",
                    }}
                  ></td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {section.total?.toLocaleString()}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        />
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", gap: "20px" }}>
        {/* Left Column: PRE_PRIMARY and PRIMARY */}
        <div style={{ flex: 1 }}>
          {leftColumnSections.map((section, sectionIndex) => 
            renderTableSection(section, sectionIndex !== 0 || scope === "RTB")
          )}
        </div>
        
        {/* Right Column: SECONDARY */}
        <div style={{ flex: 1 }}>
          {rightColumnSections.map((section) => 
            renderTableSection(section, true) // Always paginate SECONDARY
          )}
        </div>
      </div>
    </div>
  );
}
